/**
 * Converts numeric enum type to keys array
 */
export function convertNumericEnumToKeys(
  values: Record<string, unknown>,
): unknown[] {
  const enumValues = [];
  for (const key in values) {
    const value = values[key];
    if (Number.isInteger(value)) {
      enumValues.push(key);
    }
  }
  return enumValues;
}

/**
 * Converts enum type to values array
 */
export function convertEnumToValues(
  keyvalues: Record<string, unknown>,
): unknown[] {
  return Object.values(keyvalues);
}

/**
 * Converts enum type to keys array
 */
export function convertEnumToKeys(
  keyvalues: Record<string, unknown>,
): unknown[] {
  return Object.keys(keyvalues);
}
